export default "__VITE_ASSET__754b5eb3__"